import React from 'react';
import LocalizedMessage from 'react-l10n';

function OrderItemsDetailHeader(props) {
    return (
        <div className='data-table__header'>
            <div className='data-table__tr' role='row'>
                <div className='data-table__th dt-cart-summary hidden-xs hidden-sm'>
                    <span className='data-table__heading'>
                        <LocalizedMessage id={'Image'} />
                    </span>
                </div>
                <div className='data-table__th dt-cart-summary hidden-xs hidden-sm'>
                    <span className='data-table__heading'>
                        <LocalizedMessage id={'SKU'} />
                    </span>
                </div>
                <div className='data-table__th dt-cart-summary hidden-xs hidden-sm'>
                    <span className='data-table__heading'>
                        <LocalizedMessage id={'ITEM'} />
                    </span>
                </div>
                <div className='data-table__th dt-cart-summary hidden-xs hidden-sm'>
                    <span className='data-table__heading'>
                        <LocalizedMessage id={'ORDER_QUANTITY_REQUIRED'} />
                    </span>
                </div>
                <div className='data-table__th dt-cart-summary hidden-xs hidden-sm'>
                    <span className='data-table__heading'>
                        <LocalizedMessage id={'ORDER_QUANTITY_PICKED'} />
                    </span>
                </div>
                <div className='data-table__th dt-cart-summary hidden-xs hidden-sm'>
                    <span className='data-table__heading'>
                        <LocalizedMessage id={'ORDER_QUANTITY_BO'} />
                    </span>
                </div>
            </div>
        </div>
    );
}

// default props
OrderItemsDetailHeader.defaultProps = {
    // message: '',
};
// validate props
OrderItemsDetailHeader.propTypes = {
    // message: PropTypes.string,
};

export default OrderItemsDetailHeader;
